<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" slim>
    <form @submit.prevent="handleSubmit(saveShift)" class="justify-content-between col-lg-12 py-3">
      <div class="form-row align-items-center py-3">
        <DateInputField
            class="form-group col-md-4" v-model="startDate"
            labelText="datum" required
            :inMonth="getYearMonthAsString()"/>

        <ValidationObserver tag="span" class="form-row align-items-center col-md-8">
          <TimeInputField
              class="form-group col-md-6" v-model="labourStart"
              labelText="startuur" required
              vid="startTime"/>
          <TimeInputField
              class="form-group col-md-6" v-model="labourEnd"
              labelText="einduur" required
              :crossFieldRules="['notSame:@startTime']"/>
        </ValidationObserver>
      </div>

      <div class="form-row pb-3 mx-4">
        <div class="input-group">
          <div class="custom-control custom-switch">
            <input
                type="checkbox" class="custom-control-input"
                id="createTakenABreak"
                @change="createToggleBreakHours" v-model="createBreakChecked"/>
            <label class="custom-control-label" for="createTakenABreak">Pauze genomen?</label>
          </div>
          <div class="custom-control custom-switch" style="margin-left: 1em">
            <input
                type="checkbox" class="custom-control-input"
                id="createInterrupted"
                @change="createToggleInterrupted" v-model="createInterruptedChecked"/>
            <label class="custom-control-label" for="createInterrupted">Onderbroken?</label>
          </div>
          <div class="custom-control custom-switch ml-3">
            <input
                type="checkbox" class="custom-control-input"
                id="createCallout"
                @change="createToggleCallout" v-model="createCalloutChecked"/>
            <label class="custom-control-label" for="createCallout">Oproep?</label>
          </div>
        </div>
      </div>

      <div class="form-row align-items-center py-3">
        <ValidationObserver
            v-show="createBreakChecked"
            tag="span" class="form-row align-items-center col-md-8">
          <TimeInputField
              class="form-group col-md-6" v-model="breakStart"
              labelText="pauze startuur" vid="breakStartTime"
              :crossFieldRules="['bothRequiredOrBothNot:@breakEndTime']"/>
          <TimeInputField
              class="form-group col-md-6" v-model="breakEnd"
              labelText="pauze einduur" vid="breakEndTime"
              :crossFieldRules="['bothRequiredOrBothNot:@breakStartTime|notSame:@breakStartTime']"/>
        </ValidationObserver>
        <TextInputField
            labelText="opmerking" class="form-group col-md-4"
            v-model="remark" maxLength="44"/>
      </div>

      <div v-show="createCalloutChecked" class="form-row align-items-center py-3">
        <ValidationProvider
            tag="div" class="ml-2 d-flex flex-row"
            name="callout"
            v-slot="{ errors }">
          <div class="form-check mr-5">
            <input
                class="form-check-input" type="radio"
                id="nocallout" value=""
                v-model="calloutValue"/>
            <label class="form-check-label" for="nocallout">Geen oproep</label>
          </div>
          <div class="form-check mr-5">
            <input
                class="form-check-input" type="radio"
                id="callout24" value="CALL_OUT_24"
                v-model="calloutValue"/>
            <label class="form-check-label" for="callout24">Oproep 24</label>
          </div>
          <div class="form-check">
            <input
                class="form-check-input" type="radio"
                id="callout48" value="CALL_OUT_48"
                v-model="calloutValue"/>
            <label class="form-check-label" for="callout48">Oproep 48</label>
          </div>
          <div class="pl-3 col-lg-8">
            <span class="text-red">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>

      <div class="form-row align-items-center py-3">
        <ValidationProvider
            tag="div" class="form-group col-md-6 col-sm-12"
            rules="required"
            name="klant" v-slot="{ errors }">
          <label for="klant">Klant</label>
          <select
              id="klant"
              class="form-control"
              v-model="contractId">
            <option
                v-for="contract in activeContracts" :key="contract.id"
                :value="contract.id">{{ contract.customerName }}
            </option>
          </select>
          <span class="text-red">{{ errors[0] }}</span>
        </ValidationProvider>
        <ValidationProvider
            tag="div" class="form-group col-md-6 col-sm-12"
            name="shift type" v-slot="{ errors }">
          <label for="shifttype">Shift-type</label>
          <select
              id="shifttype"
              class="form-control"
              v-model="shiftTypeId">
            <option value="undefined">Kies een shift</option>
            <option
                v-for="shiftType in calculatedShifts" :key="shiftType.id"
                :value="shiftType.id">{{ shiftType.name }}
            </option>
          </select>
          <span class="text-red">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <div class="form-row align-items-center py-3">
        <div class="input-group col-6">
          <button
              type="submit" :disabled="invalid"
              class="btn-basic btn-fill-pulse">
            Shift opslaan
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>

import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {toYearAndMonth} from "@/util/DateUtil";
import TextInputField from "@/components/inputFields/TextInputField";
import DateInputField from "@/components/inputFields/DateInputField";
import TimeInputField from "@/components/inputFields/TimeInputField";

export default {
  name: "CreateWorkedShift",
  components: {
    TimeInputField,
    DateInputField,
    TextInputField,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      labourStart: "",
      labourEnd: "",
      breakStart: "",
      breakEnd: "",
      startDate: "",
      remark: "",
      shiftTypeId: undefined,
      contractId: undefined,
      createBreakChecked: false,
      createInterruptedChecked: false,
      createCalloutChecked: false,
      calloutValue: null,
    };
  },
  computed: {
    ...mapGetters({
      completed: "timesheet/completed",
      activeContracts: "timesheet/activeContracts",
      currentlySelectedMonth: "time/currentlySelectedMonth"
}
        ),
    calculatedShifts() {
      if (!this.contractId && this.activeContracts.length) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.contractId = this.activeContracts[0].id;
      }
      const currentContract = this.activeContracts.filter(contract => contract.id === this.contractId);
      return currentContract.length ? currentContract[0].shiftTypes : [];
    }
  },
  methods: {
    ...mapActions("timesheet", ['addWorkedShift']),
    saveShift() {
      if (!this.completed) {
        let endDate = this.startDate;
        if (moment(this.labourStart).diff(this.labourEnd, 'hours') < 0) {
          endDate = moment(this.startDate).add(1, 'day');
        }
        const createWorkedShiftDto = {
          date: this.startDate,
          remark: this.remark,
          callout: this.calloutValue,
          labourPeriod: {
            startDateTimestamp: this.startDate + 'T' + this.labourStart,
            endDateTimestamp: endDate + 'T' + this.labourEnd
          },
          breakPeriod: null,
          interrupted: this.createInterruptedChecked,
        };
        if (this.breakStart) {
          createWorkedShiftDto.breakPeriod = {
            startDateTimestamp: this.startDate + 'T' + this.breakStart,
            endDateTimestamp: endDate + 'T' + this.breakEnd
          };
        }
        if (this.shiftTypeId) {
          createWorkedShiftDto.shiftTypeId = this.shiftTypeId;
        }
        const yearMonth = toYearAndMonth(this.startDate);

        this.addWorkedShift({contractId: this.contractId, yearMonth, createWorkedShiftDto})
            .then(() => {
              this.resetFields();
              this.$emit('shiftAdded');
            });
      }
    },
    resetFields() {
      this.labourStart = "";
      this.labourEnd = "";
      this.breakStart = "";
      this.breakEnd = "";
      this.startDate = "";
      this.remark = "";
      this.shiftTypeId = undefined;
      this.contractId = undefined;
      this.createBreakChecked = false;
      this.createInterruptedChecked = false;
      this.createCalloutChecked = false;
      this.calloutValue = null;
    },
    createToggleBreakHours(arg) {
      this.createBreakChecked = arg.target.checked;
    },
    createToggleInterrupted(arg) {
      this.createInterruptedChecked = arg.target.checked;
    },
    createToggleCallout(arg) {
      this.createCalloutChecked = arg.target.checked;
    },
    getYearMonthAsString() {
      return toYearAndMonth(this.currentlySelectedMonth);
    }
  }
};
</script>

<style scoped>

.text-red {
  color: red;
}

</style>
